import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { RapidsLocale } from './locale';
import { formatLabelsForI18next, type I18nResources } from './i18n-utils';

// Re-export utilities for convenience
export { formatLabelsForI18next, type I18nResources };

/**
 * Create and export the i18n instance
 */
export const i18n = i18next.createInstance();

/**
 * Initialize i18next with pre-loaded resources from Contentful
 * This runs on both server and client
 *
 * CRITICAL: Must be synchronous (not async) since resources are pre-loaded
 * CRITICAL: Guards against double-initialization
 *
 * @param resources - Pre-loaded i18next resources from Contentful
 * @param locale - The current locale
 */
export const initI18next = (
  resources: I18nResources,
  locale: RapidsLocale
): void => {
  // Guard against double-initialization
  if (!i18n.isInitialized) {
    i18n
      .use(initReactI18next)
      .init({
        resources,
        lng: locale,
        fallbackLng: RapidsLocale.EN,
        defaultNS: 'translation',

        // Important for Next.js App Router
        react: {
          useSuspense: false,
        },

        interpolation: {
          escapeValue: false, // React already escapes
        },

        // Type safety
        returnNull: false,
        returnEmptyString: false,

        // Enable debug mode in development
        debug: process.env.NODE_ENV === 'development',
      });
  }
};
